import { ActivityBlockConfigData, ChatConfigData, EmptyMessageConfigData, ExpressionType, GeneratePopularity, MessageConfigData, PostConfigData, ProjectVoting, ProjectVotingForChat } from "../Shared/Party/PartyConfigData";
import { ContentPackageConfigData, DefaultContentPackageConfigData } from "../Shared/Party/ContentPackage";
import { ContentContextData, ContentServerPackage, ContextTrigger, DefaultContentContextData, ReturningPaymentStatus } from "../Shared/Party/ContentContext";
import { InstantActivity } from "../Shared/Schedule/ScheduleActivity";

import { EmptyWeeklyActivity, WeeklyActivity } from "../Shared/Map/MapData";
import { CognitoIdentity, EmptyUserData, UserAction, UserData } from "../Shared/UserData";
import { GetUserDataFromGoogleOAuth } from "../User/CommonAuth";



export type StateManager = {
    addTickListener(id: number, f: (state: StateManager, tick: number) => void): void,
    removeTickListener(id: number): void,
    main(): ContentPackageConfigData,
    setMain(main: ContentPackageConfigData): void,
    context(): ContentContextData,
    setContext(context: ContentContextData): void,
    userMessages(): UserMessages,
    userPosts(): UserMessages,
    updateCognito(cognitoIdentity: CognitoIdentity | undefined): void,
    ui(): UIStateManager,
    user(): UserData,
    activity(): InstantActivity,
    weeklyActivity(): WeeklyActivity,
    addUserMessage(message: MessageConfigData, chatId: string, timeBase : number, optionality : number, impressions : number): MessageConfigData;
    addNotifyMainUpdateFunction: (id: number, func: (state: StateManager) => void) => void,
    removeNotifyMainUpdateFunction: (id: number) => void;
    addNotifyContextUpdateFunction: (id: number, func: (state: StateManager) => void) => void,
    removeNotifyContextUpdateFunction: (id: number) => void;
    addNotifyNextContextUpdateFunction: (id: number, func: (context: ContentContextData) => void) => void,
    removeNotifyNextContextUpdateFunction: (id: number) => void;
    init(loaded: () => void, showSignup: () => void): void;
    setTriggerHandler: (handler: (itemId: string) => void) => void;
    inner?: _StateManager;
    activateTriggers(): void;
    getObjId: () => string;
    partyId: () => string | undefined;
    offset: () => number | undefined;
    devMode: () => boolean;
    paymentThankyou : () => ReturningPaymentStatus;
}

export type _StateManager = {
    listeners: { id: number, f: (manager: StateManager, tick: number) => void }[];
    main: ContentPackageConfigData,
    nextMain?: ContentPackageConfigData,
    context: ContentContextData,
    nextContext?: ContentContextData,
    userMessages: [UserMessages, _UserMessages],
    userPosts: [UserMessages, _UserMessages],
    ui: UIStateManager,
    activity: InstantActivity;
    nextActivity?: InstantActivity;
    user: UserData;
    notifyMainDisplayUpdate: { id: number, func: (state: StateManager) => void }[];
    notifyContextDisplayUpdate: { id: number, func: (state: StateManager) => void }[];
    notifyNextContextDisplayUpdate: { id: number, func: (context: ContentContextData) => void }[];
    outer?: StateManager,
    weeklyActivity: WeeklyActivity,
    triggerHandler?: (itemId: string) => void;
    triggersActive: boolean;
    partyId?: string;
    offset?: number;
    showSignup: () => void;
    inInitFlag: boolean;
    objId: string;
    devUser?: string;
    paymentThankyou: ReturningPaymentStatus;
}

/*type __StateManager = {
    main: ContentPackageConfigData,
    context: ContentContextData,
    userMessages: __UserMessages,
    ui: UIStateManager
}*/

const LoadWeeklyActivity = async (): Promise<WeeklyActivity> => {
    const uri = '/api/weeklyactivity'
    const response = await fetch(uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
    });
    const payload = await response.json() as WeeklyActivity;
    sessionStorage.setItem('FanboxWeeklyActivity', JSON.stringify(payload));
    return payload;

}

const loadUserData = (userData: UserData, state: _StateManager) => {

    /*const lookup : { [key : string] : number} = {};
    const current = state.userMessages[1].messages.map((row, index) => {
        lookup[row.message.itemId] =  index;
        return row.message.itemId;

    })*/

    const messages: { chatId: string; time: number; message: MessageConfigData; }[] = [];
    /*Object.keys(userData.messages).forEach((chatId) => {
        const mstack = userData.messages[chatId];
        mstack.forEach((row) => {
            //if (!current.includes(row.message.itemId)) {
                messages.push({ chatId: chatId, time: row.time, message: row.message });
            //}
        })
    });
    state.userMessages[1].messages = messages;*/

    const posts: UserMessageRecord[] = [];
    Object.keys(userData.posts).forEach((chatId) => {
        const pstack = userData.posts[chatId];
        pstack.forEach((row) => {
            //if (!current.includes(row.message.itemId)) {
            posts.push({ chatId: chatId, time: row.time, message: row.message, expiry : row.time + 300000000, optionality : 1, impressions : 10000 });
            //}
        })
    });
    state.userPosts[1].messages = posts;

    state.user.actions = userData.actions;
    state.paymentThankyou = state.user.returningPaymentStatus ?? 'none';
}

var _pack_next_in_progress = false;
var _pack_now_in_progress = false;
const CheckNextPackage = (state: _StateManager, tick: number, init?: () => void, loadWeek?: boolean) => {
    if (_pack_next_in_progress || _pack_now_in_progress)
        return;
    var updateMain = false;
    var updateContext = false;
    var reset = false;
    if (state.main.endTime < tick) {
        if (state.nextMain !== undefined) {
            state.main = state.nextMain;
            //sessionStorage.setItem("FanboxMain", sessionStorage.getItem("FanboxNextMain") ?? '');
            //sessionStorage.removeItem("FanboxNextMain");
            console.log('Loading stateManager main with next =>' + state.main.main.activityType + (state.main.main.activityType === 'chat' ? (state.main.main.config as ChatConfigData).itemId : ''));
            state.nextMain = undefined;
        }
        if (state.nextActivity !== undefined) {
            state.activity = state.nextActivity;
            //sessionStorage.setItem("FanboxInstantActivity", sessionStorage.getItem("FanboxNextInstantActivity") ?? '');
            //sessionStorage.removeItem("FanboxNextInstantActivity");
            state.nextActivity = undefined;

        }
        reset = state.main.endTime < tick;
        updateMain = true;
    }

    if (state.context.endTime < tick) {
        if (state.nextContext !== undefined) {
            state.context = state.nextContext;
            //sessionStorage.setItem("FanboxContext", sessionStorage.getItem("FanboxNextContext") ?? '');
            //sessionStorage.removeItem("FanboxNextContext");
            state.nextContext = undefined;
        }

        reset = reset || state.context.endTime < tick;
        updateContext = true;
    }

    if (reset) {
        state.main = DefaultContentPackageConfigData();
        state.context = DefaultContentContextData();
        const asLoad = async () => {
            const uri = state.partyId === undefined ? '/api/content/now' : '/devapi/content/now';

            const data = {
                partyId: state.partyId,
                offset: state.offset ?? 0,
                userId: state.user.fanbox.id,
                accessToken: state.user.fanbox.accessToken ?? ''
            }
            const response = await fetch(uri, {
                method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify(data)
            });
            const payload = (await response.json()).package as ContentServerPackage;
            state.main = payload.content;
            state.activity = payload.activity;
            sessionStorage.setItem("FanboxInstantActivity", JSON.stringify(payload.activity));
            sessionStorage.setItem("FanboxMain", JSON.stringify(payload.content));
            if (payload.userData !== undefined) {
                loadUserData(payload.userData, state);
            }


            if (payload.context !== undefined) {
                state.context = payload.context;
                sessionStorage.setItem("FanboxContext", JSON.stringify(payload.context));
            }

            console.log('Loading Now State From Server: Main InstanstActivity ' + (payload.context !== undefined ? ' Context ' : ''))

            state.notifyMainDisplayUpdate.forEach((row) => { if (state.outer !== undefined) row.func(state.outer) });
            if (payload.context !== undefined)
                state.notifyContextDisplayUpdate.forEach((row) => { if (state.outer !== undefined) row.func(state.outer) })

            _pack_now_in_progress = false;
            if (loadWeek) {

                const nwa = await LoadWeeklyActivity();
                state.weeklyActivity = nwa;
                if (init !== undefined)
                    init();

            }
            else if (init !== undefined)
                init();
            /*_pack_next_in_progress = true;
            const uriNext = '/api/party/next/'
            const responseNext = await fetch(uriNext, {
                method: "GET",
                headers: { "content-type": "application/json" }
            });
            const payloadNext = await responseNext.json() as ContentServerPackage;
            state.nextMain = payloadNext.content;
            state.nextActivity = payloadNext.activity;
            sessionStorage.setItem("FanboxNextContent", JSON.stringify(payloadNext.content));
            sessionStorage.setItem("FanboxNextInstantActivity", JSON.stringify(payloadNext.activity));
            if (payload.context !== undefined) {
                state.nextContext = payloadNext.context;
                sessionStorage.setItem("FanboxNextContext", JSON.stringify(payloadNext.context));
            }
            _pack_next_in_progress = false;*/

        };
        _pack_now_in_progress = true;
        asLoad();
    }
    else {
        if (state.nextMain === undefined) {
            const asLoad = async () => {
                //const uri = './api/content/next';
                const uri = state.partyId === undefined ? '/api/content/next' : '/devapi/content/next';
                const data = {
                    partyId: state.partyId,
                    offset: state.offset ?? 0,
                    userId: state.user.fanbox.id,
                    accessToken: state.user.fanbox.accessToken ?? ''
                }
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(data)
                });
                const payload = (await response.json()).package as ContentServerPackage;
                state.nextMain = payload.content;
                console.log('main payload received till :' + Math.floor((payload.content.startTime - Date.now()) / 1000) + ' until :' + Math.floor((payload.content.endTime - Date.now()) / 1000));
                state.nextActivity = payload.activity;
                sessionStorage.setItem("FanboxNextMain", JSON.stringify(payload.content));
                sessionStorage.setItem("FanboxNextInstantActivity", JSON.stringify(payload.activity));
                console.log('Loading Next State From Server: Main InstanstActivity ' + (payload.context !== undefined ? ' Context ' : ''))
                if (payload.context !== undefined) {
                    state.nextContext = payload.context;
                    sessionStorage.setItem("FanboxNextContext", JSON.stringify(payload.context));
                    state.notifyNextContextDisplayUpdate.forEach((row) => { if (state.outer !== undefined) if (payload.context !== undefined) row.func(payload.context) });
                }
                if (payload.userData !== undefined) {
                    loadUserData(payload.userData, state);
                }
                _pack_next_in_progress = false;

            };
            _pack_next_in_progress = true;
            asLoad();
        }
        if (updateMain) {
            console.log('Calling all UI update handlers for Main Change =>' + state.main.main.activityType + (state.main.main.activityType === 'chat' ? (state.main.main.config as ChatConfigData).itemId : ''));
            state.notifyMainDisplayUpdate.forEach((row) => {
                if (state.outer !== undefined) row.func(state.outer)
            });
        }
        if (updateContext)
            state.notifyContextDisplayUpdate.forEach((row) => { if (state.outer !== undefined) row.func(state.outer) });
        if (loadWeek) {
            const f = async () => {
                const nwa = await LoadWeeklyActivity();
                if (init !== undefined)
                    init();
            };
            f();
        }
        else if (init !== undefined)
            init();

    }
}


export const CreateStateManager = (cognitoIdentity: CognitoIdentity | undefined, partyId?: string, offset?: number, devUser?: string): StateManager => {

    const createUserDev = devUser === 'create';
    if (createUserDev)
        devUser = undefined;


    const userData = EmptyUserData((devUser !== undefined) ? devUser : crypto.randomUUID());
    userData.cognito = cognitoIdentity;

    const sessionMain = null; //sessionStorage.getItem("FanboxMain");
    const sessionNextMain = null;//sessionStorage.getItem("FanboxNextMain");

    const sessionContext = null; //sessionStorage.getItem("FanboxContext");
    const sessionNextContext = null; //sessionStorage.getItem("FanboxNextContext");

    const sessionInstantActivity = null; //sessionStorage.getItem('FanboxInstantActivity');
    const sessionNextInstantActivity = null;// sessionStorage.getItem('FanboxNextInstantActivity');

    const sessionUserMessages = null; //sessionStorage.getItem("FanboxUserMessages");
    const sessionUserPosts = null;
    const sessionUI = null; // sessionStorage.getItem("FanboxUI");
    const sessionWeeklyActivity = null;// sessionStorage.getItem('FanboxWeeklyActivity');

    console.log('Loading from Session State :' + (sessionMain !== null ? ' SessionMain ' : '') + (sessionContext !== null ? ' SessionContext' : '') + (sessionInstantActivity !== null ? ' SessionInstantActivity ' : '') + ((sessionContext === null && sessionMain === null && sessionInstantActivity === null) ? ' NONE ' : ''));
    console.log('Loading from Next Session State :' + (sessionNextMain !== null ? ' SessionMain ' : '') + (sessionNextContext !== null ? ' SessionContext' : '') + (sessionNextInstantActivity !== null ? ' SessionInstantActivity ' : '') + ((sessionNextContext === null && sessionNextMain === null && sessionNextInstantActivity === null) ? ' NONE ' : ''));


    const weeklyActivity: WeeklyActivity | null = (() => {
        if (sessionWeeklyActivity !== null) {
            console.log('Loading Session Weekly Acitivity');
            const wao = JSON.parse(sessionWeeklyActivity) as WeeklyActivity;
            const today = new Date();
            const wok = wao.year === today.getUTCFullYear() && wao.month === today.getUTCMonth() && wao.day === today.getUTCDate();
            if (wok)
                return wao;
            else {
                sessionStorage.removeItem("FanboxWeeklyActivity");
                console.log('Discarding outdated Weekly Activity');
                return null;
            }
        }
        else
            return null;
    })();

    const updateCognito = async (sm: _StateManager, cognito: CognitoIdentity | undefined) => {
        console.log('updateCognito called with cognito = ' + cognito?.id);
        if (cognito === undefined && sm.user.cognito?.provider !== 'Fanbox') {
            console.log('user logged out in updateCognito');
            sm.user = EmptyUserData(crypto.randomUUID());

        }
        else if (cognito !== undefined) {
            const result = await GetUserDataFromGoogleOAuth(cognito);
            if ((!result.error) && (result.userData !== null)) {
                sm.user = result.userData;
                sm.paymentThankyou = sm.user.returningPaymentStatus ?? 'none';
                const um = sm.userMessages[1];
                um.messages.forEach((row) => {
                    row.message.nickname = inner.user.userInformation.nickname;
                    row.message.userColor = inner.user.userInformation.displayColor;
                    row.message.userIcon = inner.user.userInformation.displayIcon;
                    row.message.userId = inner.user.fanbox.id;
                });

                /*Object.keys(sm.user.messages).forEach((key)=> {
                    
                    const chMatch = Array<{chatId: string; time: number;message: MessageConfigData;}>();
                    um.messages.forEach((row)=> {
                        if(row.chatId === key)
                            chMatch.push(row);
                    })
                    const instances = sm.user.messages[key];
                    instances.forEach((umi) => {
                        var found = false;
                        for(let i = 0; i < chMatch.length; i++){
                            if(chMatch[i].message.itemId === umi.message.itemId){
                                chMatch.splice(i,1);
                                found = true;
                            }
                        }
                        if(!found){
                            um.messages.push({ chatId : key, time : umi.time, message : umi.message});
                        }
                    })
                    
                })*/

                const posts: UserMessageRecord[] = [];
                Object.keys(sm.user.posts).forEach((chatId) => {
                    const pstack = sm.user.posts[chatId];
                    pstack.forEach((row) => {
                        //if (!current.includes(row.message.itemId)) {
                        posts.push({ chatId: chatId, time: row.time, message: row.message, expiry : Date.now() + 300000000, optionality : 1, impressions : 10000 });
                        //}
                    })
                });
                sm.userPosts[1].messages = posts;
            }
            if (result.newUser)
                sm.showSignup();
            /*else {
                await tryStoredPayment(sm);
            }*/
        }
    }

    /*const tryStoredPayment = async (sm: _StateManager): Promise<boolean> => {

        const storedPaymentString = sessionStorage.getItem('Fanbox.StoredPayment');
        var result = false;
        if (storedPaymentString !== null) {
            const storedPayment = JSON.parse(storedPaymentString);

            if (sm.user.fanbox.id === storedPayment.userId) {

                const uri = '/api/payments/succeeded';

                console.log('sending request to the server for payment confirmation')

                const dataPackage = {
                    fanboxId: inner.user.fanbox.id,
                    accessToken: inner.user.fanbox.accessToken ?? '',
                    token: storedPayment.token
                }
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(dataPackage)
                });
                const json = await response.json();
                console.log('payment confirmation response received');
                const error = json.error as boolean;
                if (!error) {

                    const boostsPurchased = (json).boostsPurchased as number;
                    inner.user.accountInformation.boostBalance += boostsPurchased;
                    result = true;
                    console.log('payment confirmed! - boostBalance =' + inner.user.accountInformation.boostBalance);
                }
                sessionStorage.removeItem('Fanbox.StoredPayment');
            }
        }
        return result;
    }*/



    const inner: _StateManager = {
        listeners: [],
        objId: crypto.randomUUID(),
        inInitFlag: false,
        main: sessionMain === null ? DefaultContentPackageConfigData() : JSON.parse(sessionMain) as ContentPackageConfigData,
        context: sessionContext === null ? DefaultContentContextData() : JSON.parse(sessionContext) as ContentContextData,
        nextMain: sessionNextMain === null ? undefined : JSON.parse(sessionNextMain) as ContentPackageConfigData,
        nextContext: sessionNextContext === null ? undefined : JSON.parse(sessionNextContext) as ContentContextData,
        userMessages: sessionUserMessages === null ? CreateUserMessages() : CreateUserMessages(JSON.parse(sessionUserMessages) as __UserMessages),
        userPosts: sessionUserPosts === null ? CreateUserMessages() : CreateUserMessages(JSON.parse(sessionUserPosts) as __UserMessages),
        ui: sessionUI === null ? {
            videoIndex: 0,
            videoTime: 0,
            timeOffset: 0,
            liveFeedTimings: {},
            postElementIndex: { itemId: '', index: 0 }
        } : JSON.parse(sessionUI) as UIStateManager,
        activity: sessionInstantActivity === null ? {
            time: 0,
            national: 0,
            states: {},
            stateLevels: {}
        } : JSON.parse(sessionInstantActivity) as InstantActivity,
        nextActivity: sessionNextInstantActivity === null ? undefined : JSON.parse(sessionNextInstantActivity) as InstantActivity,
        user: userData,
        notifyMainDisplayUpdate: [],
        notifyContextDisplayUpdate: [],
        notifyNextContextDisplayUpdate: [],
        weeklyActivity: weeklyActivity !== null ? weeklyActivity : EmptyWeeklyActivity(),
        triggersActive: false,
        partyId: partyId,
        offset: offset,
        showSignup: () => { },
        devUser: devUser,
        paymentThankyou : 'none'

    }
    const outer: StateManager = {
        getObjId: () => inner.objId,
        addTickListener: (id: number, f: (state: StateManager, tick: number) => void) => {
            inner.listeners.push({ id: id, f: f });
        },
        removeTickListener: (id: number) => {
            var found = -1;
            for (let i = 0; i < inner.listeners.length; i++) {
                if (id === inner.listeners[i].id) {
                    found = i;
                    i = inner.listeners.length;
                }
            }
            //if (found >= 0)
            //  inner.listeners.splice(found, 1);
        },
        main: () => inner.main,
        setMain: (main: ContentPackageConfigData) => { inner.main = main; },
        context: () => inner.context,
        setContext: (context: ContentContextData) => { inner.context = context; },
        userMessages: () => inner.userMessages[0],
        userPosts: () => inner.userPosts[0],
        ui: () => inner.ui,
        user: () => inner.user,
        activity: () => inner.activity,
        weeklyActivity: () => inner.weeklyActivity,
        addNotifyMainUpdateFunction: (id: number, func: (state: StateManager) => void) => {
            inner.notifyMainDisplayUpdate.push({ id: id, func: func });
        },
        removeNotifyMainUpdateFunction: (id: number) => {
            for (let i = 0; i < inner.notifyMainDisplayUpdate.length; i++) {
                if (inner.notifyMainDisplayUpdate[i].id === id) {
                    //inner.notifyMainDisplayUpdate.splice(i, 1);
                    i = 10000000;
                }
            }
        },
        addNotifyContextUpdateFunction: (id: number, func: (state: StateManager) => void) => {
            inner.notifyContextDisplayUpdate.push({ id: id, func: func });
        },
        removeNotifyContextUpdateFunction: (id: number) => {
            for (let i = 0; i < inner.notifyContextDisplayUpdate.length; i++) {
                if (inner.notifyContextDisplayUpdate[i].id === id) {
                    //inner.notifyContextDisplayUpdate.splice(i, 1);
                    i = 10000000;
                }
            }
        },
        addNotifyNextContextUpdateFunction: (id: number, func: (context: ContentContextData) => void) => {
            inner.notifyNextContextDisplayUpdate.push({ id: id, func: func });
        },
        removeNotifyNextContextUpdateFunction: (id: number) => {
            for (let i = 0; i < inner.notifyContextDisplayUpdate.length; i++) {
                if (inner.notifyNextContextDisplayUpdate[i].id === id) {
                    //inner.notifyContextDisplayUpdate.splice(i, 1);
                    i = 10000000;
                }
            }
        },
        updateCognito: async (cognito: CognitoIdentity | undefined) => {
            updateCognito(inner, cognito);
        },
        addUserMessage: (message: MessageConfigData, chatId: string, timeBasis : number, optionality : number, impressions : number) : MessageConfigData => {
            if (inner !== undefined) {
                const time = Date.now();

                inner.userMessages[1].messages.push({ chatId: chatId, time: time, message: message, expiry : time + timeBasis, optionality : optionality, impressions : impressions });
                /*if (index !== undefined) {
                    const chat = inner.main.chat !== undefined ? (inner.main.chat.itemId === chatId ? inner.main.chat : inner.context.chats[chatId]) : inner.context.chats[chatId];
                    if (chat !== undefined) {
                        if (index < chat.messages.length)
                            chat.messages.splice(index, 0, message);
                        else chat.messages.push(message);
                    }
                }*/


                return message;
            }
            else
                return message;
        },
        inner: inner,
        init: async (loaded: () => void, showSignup: () => void) => {
            inner.showSignup = showSignup;

            console.log('stateManager.init called on ' + inner.objId + ', flag = ' + inner.inInitFlag);
            if (inner.inInitFlag) {
                console.log('inInitFlag set, returning');
                return;
            }
            inner.inInitFlag = true;



            if (inner.devUser !== undefined) {
                const uri = '/devapi/user/get';

                console.log('devUser specified, using devapi to retieve user Info')

                const dataPackage = {
                    fanboxId: devUser,
                }
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(dataPackage)
                });
                const result = await response.json();
                inner.user = result.userData;
                inner.paymentThankyou = inner.user.returningPaymentStatus ?? 'none';
                //tryStoredPayment(inner);
            }
            else if (createUserDev) {
                const uri = '/devapi/user/create';

                console.log('devUser creation specified, using devapi to create user Info')

                const dataPackage = {
                    fanboxId: userData.fanbox.id,
                }
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(dataPackage)
                });
                const result = await response.json();
                inner.user = result.userData;
                devUser = inner.user.fanbox.id;
                window.history.pushState('created:' + userData.fanbox.id, 'Fanbox', '/devuser/' + (partyId ?? '_00000002') + '/' + (offset ?? 0) + '/' + userData.fanbox.id);
                showSignup();
            }

            inner.inInitFlag = false;
            console.log('current status userId = ' + inner.user.fanbox.id + ' fully signed up = ' + inner.user.userInformation.signUpComplete + ' smid = ' + inner.objId);


            CheckNextPackage(inner, Date.now(), loaded, weeklyActivity === null);

            window.setInterval(() => {
                const time = Date.now();
                CheckNextPackage(inner, time);
                UpdateContentPackage(inner.main, time, inner.activity.national);
                UpdateContext(inner.context, time, inner.activity.national);
                outer.userMessages().update();
                //inner.userMessages[1].tick(time);
                if (inner.triggersActive) {
                    const potentialTriggers = Array<ContextTrigger>();
                    inner.context.triggers.forEach((trigger) => {
                        if ((trigger.time < time) && (!trigger.fired) && (trigger.deactivate > time)) {
                            potentialTriggers.push(trigger);
                        }
                    })
                    potentialTriggers.sort((a, b) => b.time - a.time);
                    if (potentialTriggers.length > 0) {
                        if (inner.triggerHandler !== undefined) {
                            inner.triggerHandler(potentialTriggers[0].itemId);
                        }
                        potentialTriggers[0].fired = true;
                    }
                }

                inner.listeners.forEach((row) => {
                    if (outer !== undefined)
                        row.f(outer, time);
                });



                const saveUserMsg: __UserMessages = {
                    messages: inner.userMessages[1].messages
                }

                //sessionStorage.setItem("FanboxPlayerState", JSON.stringify(saveObj));
                sessionStorage.setItem("FanboxUserMessages", JSON.stringify(saveUserMsg));
                sessionStorage.setItem("FanboxUI", JSON.stringify(inner.ui));

            }, 1000)

        },
        setTriggerHandler: (handler: (itemId: string) => void) => inner.triggerHandler = handler,
        activateTriggers: () => { inner.triggersActive = true; },
        partyId: () => { return inner.partyId; },
        offset: () => { return inner.offset; },
        devMode: () => { return inner.partyId !== undefined; },
        paymentThankyou : () => { return inner.paymentThankyou; }
    }
    inner.outer = outer;
    return outer;
}


export type UIStateManager = {
    videoTime: number;
    videoIndex: number;
    timeOffset: number;
    liveFeedTimings: { [key: string]: { index: number, at: number } }
    postElementIndex: { itemId: string, index: number };
}

export type UserMessageRecord = {
    chatId :string;
    time : number;
    expiry : number;
    optionality : number;
    impressions : number;
    message : MessageConfigData;
}

export type UserMessages = {
    totalLikes(): number;
    totalComments(): number;
    totalImpressions(): number;
    update: ()=>void;

    id(): { chatId: string, time: number }[];
    get(chatId: string, time: number): MessageConfigData | null;
    getAll(chatId: string): MessageConfigData[];
    getForDisplay(): { chatId: string, time: number, message: MessageConfigData }[];

}

type _UserMessages = {
    totalLikes: number;
    totalComments: number;
    totalImpressions: number;

    messages: UserMessageRecord[];
    //tick(ticks: number): void;
    outer?: UserMessages;
}

type __UserMessages = {
    messages: UserMessageRecord[];
}

const UpdateChatTick = (chat: ChatConfigData, tick: number, online: number) => {
    if(chat.voting === undefined) {
        chat.voting = {
            itemId : chat.itemId + '_voting',
            impressions : 0,
            likes : 0,
            comments : 0,
            created : tick - 1000,
            updated : 0
        }
    }
    const fs = Math.floor(online * 0.06667);
    const fe = fs + Math.floor(Math.random() * (10 * online * 0.06667));
    ProjectVotingForChat(chat.voting, tick, online, { start : fs, end : fe });
    if (tick >= chat.startTime && tick <= (chat.endTime + 15000)) {
        chat.messages.forEach((m) => UpdateMessageTick(m, tick, online, chat.messages.length, chat.endTime - chat.startTime));
        chat.threads.forEach((t) => UpdateChatTick(t, tick, online));
    }
    else {
        console.log('Chat outside of time for update. ' + (tick < chat.startTime ? 'Before start by ' + (chat.startTime - tick) : 'After the end by ' + (tick - chat.endTime)));
    }
}

const UpdateMessageTick = (message: MessageConfigData, tick: number, online: number, numMessages: number, timeBasis: number) => {
    message.replies.forEach((reply) => UpdateMessageTick(reply, tick, online, numMessages, timeBasis));
    const fs = Math.floor(Math.random() * 10);
    const fe = fs + Math.floor(Math.random() * (25 - fs));
    ProjectVoting(message.voting, tick, online * numMessages, Math.floor(0.5 * online), timeBasis,0, { start : fs,  end : fe} );
}

const UpdateContext = (context: ContentContextData, tick: number, online: number) => {
    Object.keys(context.optional).forEach((key) => UpdateActivity(context.optional[key], tick, online));
    Object.keys(context.chats).forEach((key) => UpdateChatTick(context.chats[key], tick, online));
}

const UpdateContentPackage = (content: ContentPackageConfigData, tick: number, online: number) => {
    UpdateActivity(content.main, tick, online);
    if (content.chat !== undefined)
        UpdateChatTick(content.chat, tick, online);
}

const UpdateActivity = (activity: ActivityBlockConfigData, tick: number, online: number) => {
    if (activity.activityType === 'post') {
        const post = activity.config as PostConfigData;
        UpdatePostTick(post, tick, online, activity.endTime - activity.startTime);
    }
    else if(activity.activityType === 'chat') {
        const chat = activity.config as ChatConfigData;
        UpdateChatTick(chat, tick, online);
    }
}

const UpdatePostTick = (post: PostConfigData, tick: number, online: number, timeBasis: number) => {
    if (post.voting !== undefined) {
        const prev = post.voting.likes;
        ProjectVoting(post.voting, tick, online, 1, timeBasis);
        // console.log('Post Votes: ' + prev + '=>' + post.voting.likes);
    }

    post.elements.forEach((e) => { if (e.voting !== undefined) ProjectVoting(e.voting, tick, online, 1, timeBasis); })
}

const CreateUserMessages = (saved?: __UserMessages): [UserMessages, _UserMessages] => {

    const messages = new Array<UserMessageRecord>();
    if (saved != undefined) {
        saved.messages.forEach(row => {
            messages.push({ chatId: row.chatId, time: row.time, message: row.message, expiry : row.expiry, optionality : row.optionality, impressions : row.impressions });
        });
    }

    const inner: _UserMessages = {
        totalLikes: 0,
        totalComments: 0,
        totalImpressions: 0,
        messages: messages,
        /*tick: (time: number) => {

            inner.totalLikes = 0;
            inner.totalComments = 0;
            inner.totalImpressions = 0;
            inner.messages.forEach((row) => {
                UpdateMessageTick(row.message, time);
                inner.totalComments += row.message.voting.comments;
                inner.totalImpressions += row.message.voting.impressions;
                inner.totalLikes += row.message.voting.likes;
            })
        },*/
    }

    const outer: UserMessages = {
        totalLikes: () => { return inner.totalLikes; },
        totalComments: () => { return inner.totalComments; },
        totalImpressions: () => { return inner.totalImpressions; },
        update : () => {
            const list = Array<UserMessageRecord>();
            const now = Date.now();
            var comments = 0;
            var likes = 0;
            var impressions = 0;
            inner.messages.forEach((row)=> {
                if(row.expiry > now) {
                    list.push(row);
                    ProjectVoting(row.message.voting, now, row.impressions, row.optionality, row.expiry - row.time );
                    comments+= row.message.voting.comments;
                    likes += row.message.voting.likes;
                    impressions += row.message.voting.impressions;
                }
            });

            inner.messages = list;
            inner.totalComments = comments;
            inner.totalLikes = likes;
            inner.totalImpressions = impressions;
        },

        id: () => {
            const ret = inner.messages.map((row) => {
                return { chatId: row.chatId, time: row.time };
            })
            return ret;
        },
        get: (chatId: string, time: number): MessageConfigData | null => {
            for (let i = 0; i < inner.messages.length; i++) {
                if (inner.messages[i].time === time) {
                    if (inner.messages[i].chatId === chatId) {
                        return inner.messages[i].message;
                    }
                }
            }
            return null;
        },
        getAll: (chatId: string): MessageConfigData[] => {
            const ret = Array<MessageConfigData>();
            for (let i = 0; i < inner.messages.length; i++) {
                if (inner.messages[i].chatId === chatId)
                    ret.push(inner.messages[i].message);
            }
            return ret;
        },
        getForDisplay: () => {
            return inner.messages.slice(0);
        }


    }
    return [outer, inner]

}




